// extracted by mini-css-extract-plugin
module.exports = {"container":"NearbyStationsList__container___1jrG-","nearbyStationsHeader":"NearbyStationsList__nearbyStationsHeader___2UeBg"};